const MobilePage = () => {

    return (
        <div style={{ textAlgin: "center", padding: "20px" }}>
          <h1>PC에서 접속해주세요</h1>
          <p>모바일에서 접근할 수 없는 페이지입니다.</p>
        </div>
      )

}

export default MobilePage;